import type { Transition } from "motion/react";

/** The current place's pill moving between items, quick enough to follow a tap */
export const pillSpring: Transition = { type: "spring", stiffness: 520, damping: 34 };

/** The More sheet rising and settling */
export const sheetSpring: Transition = { type: "spring", stiffness: 380, damping: 36 };

/**
 * Material 3 Expressive's default spatial curve, for what moves by CSS transition
 * rather than by `motion`: the rail's width and the content margin that follows it.
 */
export const SPATIAL_EASE = "cubic-bezier(0.38, 1.21, 0.22, 1)";
